import { createContext, useEffect, useState, useRef } from "react";
import router from "next/router";

export const PreviousPathContext = createContext();
PreviousPathContext.displayName = "PreviousPathContext";

const ignorePath = [
  "login",
  "signup",
  "profiles",
  "account",
  "password_remind",
  "profile_pincode_reset",
  "restricted",
];

export function PreviousPathProvider({ children }) {
  const previousPath = useRef();
  const [_path, setPath] = useState();
  useEffect(() => {
    const handler = (url) => {
      setPath((prev) => {
        if (prev && !ignorePath.find((path) => prev.match(new RegExp(path)))) {
          previousPath.current = prev;
        }
        return url;
      });
    };
    handler(router.asPath);
    router.events.on("routeChangeComplete", handler);
    return () => {
      router.events.off("routeChangeComplete", handler);
    };
  }, []);
  return (
    <PreviousPathContext.Provider value={previousPath.current}>
      {children}
    </PreviousPathContext.Provider>
  );
}
